import { Options } from "@components/modules/Table/types";
import { route } from "@helpers";
import useAuth from "@hooks/useAuth";
import { useMemo } from "react";
import { useHistory } from "react-router";
import filters from "../config/filters";

export default function useTableOptions() {
    const history = useHistory()
    const { loginAsUser } = useAuth()

    return useMemo<Options<Interfaces.Customer>>(() => ({
        heading: "Customers",
        filters,
        pageSize: 100,
        actions: [
            { label: "Visit", action: row => loginAsUser(row.original.id) },
            { label: "Logs", action: row => history.push(route("admin:user", row.original.id)) }
        ]
    }), [])
}